module.exports = "p {\n    margin-top: 1rem !important;\n}"